import { API } from 'aws-amplify'
import { awsApiName } from '../../shared/amplify/amplify-utils'
import { RequestBody } from '../../entity/core/request-body'

export class GrantAIAgent {

  executeAgent = async (organizationId: string, requestBody: RequestBody): Promise<any> => {
    return await API.post(awsApiName, `/organizations/${organizationId}/async-job/scraper/download`, requestBody);
  }
}
